import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';

export interface CsvExportFile {
  fileName: string;
  content: string;
  configurationId: string;
}

class PaginatedCsvExportFile extends forPaginated<CsvExportFile>() {}

const task = gql`
  mutation GenerateTaskExport(
    $taskId: String!
    $timezone: String!
    $locale: String!
    $companyId: String!
    $stockLocationId: String!
  ) {
    generateTaskExport(
      taskId: $taskId
      timezone: $timezone
      locale: $locale
      companyId: $companyId
      stockLocationId: $stockLocationId
    ) {
      fileName
      content
    }
  }
`;

export interface ExportTaskVariables {
  taskId: string;
  companyId: string;
  stockLocationId: string;
  timezone: string;
  locale: string;
}

export interface ExportTaskResponse {
  generateTaskExport: {
    fileName: string;
    content: string;
  }[];
}

const order = gql`
  mutation GenerateOrderExport(
    $orderIds: [String!]!
    $timezone: String!
    $locale: String!
    $companyId: String!
    $configurationIds: [String!]
    $page: Float
  ) {
    generateOrderExport(
      orderIds: $orderIds
      timezone: $timezone
      locale: $locale
      companyId: $companyId
      configurationIds: $configurationIds
      page: $page
    ) {
      data {
        fileName
        content
        configurationId
      }
      hasNext
      pageSize
      page
      batchSize
    }
  }
`;

export interface ExportOrderVariables {
  orderIds: string[];
  companyId: string;
  timezone: string;
  locale: string;
  configurationIds?: string[];
  page?: number;
}

export interface ExportOrderResponse {
  generateOrderExport: PaginatedCsvExportFile;
}

const product = gql`
  mutation GenerateProductExport(
    $companyId: String!
    $productIds: [String!]!
    $timezone: String!
    $locale: String!
    $configurationIds: [String!]
    $page: Float
  ) {
    generateProductExport(
      timezone: $timezone
      locale: $locale
      companyId: $companyId
      productIds: $productIds
      configurationIds: $configurationIds
      page: $page
    ) {
      data {
        fileName
        content
        configurationId
      }
      hasNext
      pageSize
      page
      batchSize
    }
  }
`;

export interface ExportProductVariables {
  companyId: string;
  productIds: string[];
  timezone: string;
  locale: string;
  configurationIds?: string[];
  page?: number;
}

export interface ExportProductResponse {
  generateProductExport: PaginatedCsvExportFile;
}

const productTransaction = gql`
  mutation GenerateProductTransactionExport(
    $companyId: String!
    $transactionIds: [String!]!
    $timezone: String!
    $locale: String!
    $configurationIds: [String!]
    $page: Float
  ) {
    generateProductTransactionExport(
      timezone: $timezone
      locale: $locale
      companyId: $companyId
      transactionIds: $transactionIds
      configurationIds: $configurationIds
      page: $page
    ) {
      data {
        fileName
        content
        configurationId
      }
      hasNext
      pageSize
      page
      batchSize
    }
  }
`;

export interface ExportProductTransactionVariables {
  companyId: string;
  transactionIds: string[];
  timezone: string;
  locale: string;
  configurationIds?: string[];
  page?: number;
}

export interface ExportProductTransactionResponse {
  generateProductTransactionExport: PaginatedCsvExportFile;
}

const productMasterData = gql`
  mutation GenerateProductMasterDataExport(
    $productMasterDataIds: [String!]!
    $companyId: String!
    $timezone: String!
    $locale: String!
    $configurationIds: [String!]
    $page: Float
  ) {
    generateProductMasterDataExport(
      productMasterDataIds: $productMasterDataIds
      timezone: $timezone
      locale: $locale
      companyId: $companyId
      configurationIds: $configurationIds
      page: $page
    ) {
      data {
        fileName
        content
        configurationId
      }
      hasNext
      pageSize
      page
      batchSize
    }
  }
`;

export interface ExportProductMasterDataVariables {
  productMasterDataIds: string[];
  companyId: string;
  timezone: string;
  locale: string;
  configurationIds?: string[];
  page?: number;
}

export interface ExportProductMasterDataResponse {
  generateProductMasterDataExport: PaginatedCsvExportFile;
}

const reorderRule = gql`
  mutation GenerateReorderRuleExport(
    $locale: String!
    $timezone: String!
    $companyId: String!
    $groupIds: [String!]!
    $page: Float
    $configurationIds: [String!]
  ) {
    generateReorderRuleExport(
      locale: $locale
      timezone: $timezone
      companyId: $companyId
      groupIds: $groupIds
      page: $page
      configurationIds: $configurationIds
    ) {
      data {
        fileName
        content
        configurationId
      }
      hasNext
      pageSize
      page
      batchSize
    }
  }
`;

export interface ExportReorderRuleVariables {
  groupIds: string[];
  companyId: string;
  timezone: string;
  locale: string;
  configurationIds?: string[];
  page?: number;
}

export interface ExportReorderRuleResponse {
  generateReorderRuleExport: PaginatedCsvExportFile;
}

export const ReportMutations = {
  task,
  product,
  order,
  productTransaction,
  productMasterData,
  reorderRule,
};
